import { Button, Checkbox, FormLabel } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { STATUS_CODES } from "constants/responses/statusCodes";
import React, { useState } from "react";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { addTaskApi } from "API/apis/task/addTask";
import dayjs from "configs/dayjs.config";

import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { useGlobalContext } from "context/GlobalContext";
import { Layout } from "components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { dateTimeFormat } from "constants/componentsConstants";

const initialState = {
  docType: 1,
  docId: 0,
  taskDetails: "",
  deadline: new Date(),
  taskTo: { name: "", dept: "", subDept: "", userId: "" },
  companyId: 0,
};
const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};

export const AddNewTask = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialState);
  const [selectedTaskByUser, setSelectedTaskByUser] =
    useState(initialUserDetail);
  const [selectedTaskToUser, setSelectedTaskToUser] =
    useState(initialUserDetail);
  const [isDelegateTask, setIsDelegateTask] = useState(false);
  const { setIsLoading, setSuccess, setError } = useGlobalContext();
  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deadline: dayjs(newValue).format(dateTimeFormat.date),
      });
    }
  };
  const handleDelegationCheckboxClick = (newValue) => {
    setIsDelegateTask(newValue);
    setSelectedTaskByUser(initialUserDetail);
  };

  const handleAddNewTaskSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formData.deadline) {
        throw new Error("Older dates are not allowed");
      }
      setIsLoading(true);
      const { data, status } = await addTaskApi({
        ...formData,
        taskTo: selectedTaskToUser?.userId || "",
        taskBy: selectedTaskByUser?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setSuccess(data?.message);
      navigate("/");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      docType: 1,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Layout>
      <>
        <PageTitle pageName={pageName.task.newTask} />
        <form onSubmit={handleAddNewTaskSubmit}>
          <TextFieldWrapper
            multiline
            id="taskDetails"
            name="taskDetails"
            label="Task Detail"
            variant="outlined"
            value={formData.taskDetails}
            fullWidth
            required
            onChange={handleChange}
          />
          <TextFieldWrapper
            multiline
            id="taskDescription"
            name="taskDescription"
            label="Task Description"
            variant="outlined"
            value={formData.taskDescription}
            rows={5}
            fullWidth
            required
            onChange={handleChange}
          />
          <FormControlWrapper fullWidth>
            <FormLabel>
              Do you want to assign the task on behalf of someone else?
              <Checkbox
                aria-label="Do you want to assign the task on behalf of someone else?"
                value={isDelegateTask}
                onChange={() => handleDelegationCheckboxClick(!isDelegateTask)}
              />
            </FormLabel>
            {isDelegateTask && (
              <SearchUsers
                label="Assign By"
                handleUserSelection={setSelectedTaskByUser}
                selectedUser={selectedTaskByUser}
              />
            )}
          </FormControlWrapper>
          <FormControlWrapper fullWidth>
            <SearchUsers
              label="Assign To"
              handleUserSelection={setSelectedTaskToUser}
              selectedUser={selectedTaskToUser}
            />
          </FormControlWrapper>
          <TextFieldWrapper
            id="alertBeforeDays"
            name="alertBeforeDays"
            label="Alert Before Days"
            variant="outlined"
            value={formData.alertBeforeDays}
            fullWidth
            inputProps={{ min: 1 }}
            required
            onChange={handleChange}
          />
          <FormControlWrapper fullWidth>
            <DatePickerWrapper
              label="Deadline"
              value={dayjs(formData.deadline)}
              onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
            />
          </FormControlWrapper>
          <Button variant="contained" type="submit" fullWidth>
            Submit
          </Button>
        </form>
      </>
    </Layout>
  );
};
